export enum KVGridColors {
  Red = 'red',
  White = 'white',
  Blue = 'blue',
  Green = 'green',
  Gray = 'gray',
  Yellow = 'yellow',
}

export type KVInspectionGridJSON = {
  gridSpacing?: number
  gridOffset?: number
  unit?: 'meters' | 'feet'
  color?: KVGridColors
  lineThickness?: number
  labelVisibility?: boolean
}

export class KVInspectionGrid {
  gridSpacing: number
  gridOffset: number
  unit: 'meters' | 'feet'
  color: KVGridColors
  lineThickness: number
  labelVisibility: boolean

  constructor() {
    this.gridSpacing = 10
    this.gridOffset = 1
    this.unit = 'meters'
    this.color = KVGridColors.Red
    this.lineThickness = 1
    this.labelVisibility = true
  }

  static fromJSON(json: KVInspectionGridJSON): KVInspectionGrid {
    const settings = new KVInspectionGrid()
    if (json.gridSpacing) settings.gridSpacing = json.gridSpacing
    if (json.gridOffset) settings.gridOffset = json.gridOffset
    if (json.unit) settings.unit = json.unit
    if (json.color) settings.color = json.color
    if (json.lineThickness) settings.lineThickness = json.lineThickness
    if (json.labelVisibility) settings.labelVisibility = json.labelVisibility

    return settings
  }
}
